module.exports = __webpack_public_path__ + "static/media/ball.fd101963.ogg";